import ProgressBar from "app/components/blogs/progress-bar";
import { useProgressBar } from "app/hooks/useProgressBar";
import { useRef } from "react";

export default function ScrolledProgressBar() {
  const ref = useRef();
  useProgressBar(ref);

  return <ProgressBar reference={ref} />;
}
